"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsx)("svg", {
    fill: "currentColor",
    width: "100%",
    height: "100%",
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 253.45 253.4",
    children: (0, jsx_runtime_1.jsx)("path", {
      d: "M426.82,131.68H342.09a8.51,8.51,0,0,0-8.5,8.5v25.4a8.5,8.5,0,0,0,17,0v-16.9h18.64v37.07l-25,25H273.79L248,184.94V148.4h22.22v16.89a8.5,8.5,0,1,0,17,0V139.9a8.51,8.51,0,0,0-8.5-8.5H190.37a8.51,8.51,0,0,0-8.5,8.5v84.73a8.51,8.51,0,0,0,8.5,8.5h25.4a8.5,8.5,0,0,0,0-17h-16.9V197.49h37.6l25.3,25.3v70.42l-25.51,25.5H198.87V300.08h16.9a8.5,8.5,0,1,0,0-17h-25.4a8.5,8.5,0,0,0-8.5,8.5V376.3a8.5,8.5,0,0,0,8.5,8.5h88.31a8.5,8.5,0,0,0,8.5-8.5V350.91a8.5,8.5,0,0,0-17,0V367.8H248V331.06l25.83-25.83h70.42l25,25v37.27H350.59V350.63a8.5,8.5,0,0,0-17,0V376a8.5,8.5,0,0,0,8.5,8.5h84.73a8.5,8.5,0,0,0,8.5-8.5v-88.3a8.5,8.5,0,0,0-8.5-8.5h-25.4a8.5,8.5,0,0,0,0,17h16.9v22.21H381.45l-25.22-25.22V222.79l25-25h37.07V220h-16.9a8.5,8.5,0,0,0,0,17h25.4a8.51,8.51,0,0,0,8.5-8.5V140.18A8.51,8.51,0,0,0,426.82,131.68ZM198.87,180.49V148.4H231v32.09ZM418.32,335.43v32.09H386.23V335.43ZM231,367.8H198.87V335.71H231Zm108.27-91.59v12H278.77V227.77h60.46v48.44Zm79.09-95.44H386.23V148.68h32.09Z",
      transform: "translate(-181.87 -131.4)"
    })
  });
};

exports.default = Icon;